<template>
  <div id="app">
    <router-view />
    <Watermark v-if="isShowWatermark" />
  </div>
</template>

<script>
import { getviewportSize, debounce } from '@/util/common';
import Watermark from '@/components/Watermark/index.vue'; // 引入水印组件
import {
  getDictionary
} from "@/api/system/dict";
export default {
  name: 'AppContainer',
  components: {
    Watermark
  },
  data() {
    return {
      isShowWatermark: false // 控制水印显示
    };
  },
  methods: {
    getSizeSync() {
      const size = getviewportSize();
      this.$store.commit('app/UPDATE_HEIGHT', size);
      console.log('viewport size:', size);
    },
    showWatermark(){
      getDictionary({code: 'web_saas_show_Watermark'}).then(res=>{
      if(res.data.code ===200 && res.data.data && Array.isArray(res.data.data) && res.data.data.length){
        // 展示水印---通过isShowWatermark判断是否展示
        this.isShowWatermark = +res.data.data[0].dictKey
      }
    })
    }
  },
  mounted() {
    this.handleResize = debounce(this.getSizeSync, 500);
    window.addEventListener('resize', this.handleResize);
    this.getSizeSync();
    setTimeout(() => {
      this.showWatermark()
    }, 500)
  },
  created(){

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
